import React, { useState, useEffect } from "react";
import { BlackAndWhite } from "../../../../../../themes/Colors";
import useWindowDimensions from "../../../../../../components/get-diemensions/UseWindowDiemensions";
import {
  BaseButtons,
  TextInputFieldSearch,
} from "../../../../../../components/atoms";
import { AddPromtions, ManagePromotions, PromotionsTable } from "./components";
import { LoadingPopUp, ToastNotification } from "../../../../../../components";

const Promotions = ({ auth }) => {
  const { width, height } = useWindowDimensions();

  const [search, setSearch] = useState("");
  const [addPromotionsPopUp, setAddPromotionsPopUp] = useState(false);
  const [selectedPromo, setSelectedPromo] = useState(null);
  const [category, setCategory] = useState(null);

  const [toastPop, setToastPop] = useState(null);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const [promotionCardArray, setPromotionCardArray] = useState(null);

  const getPromotionList = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://budloungedatabase.onrender.com/promotionRoute/getAllPromotions",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            staffUserId: auth.userId,
          }),
        }
      );
      const respnseData = await response.json();

      if (respnseData.success) {
        setPromotionCardArray(respnseData.promotions);

        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      setToastPop(true);
      setMessage("no network, please try again later");
      console.log("test", err);
    }
  };

  // need categories
  useEffect(() => {
    fetch("https://budloungedatabase.onrender.com/productUpload/getCatergories")
      .then((response) => {
        return response.json();
      })
      .then((resData) => {
        setCategory(resData.categories);
      });
  }, []);
  useEffect(() => {
    getPromotionList();
  }, [selectedPromo]);
  useEffect(() => {
    getPromotionList();
  }, []);
  useEffect(() => {
    if (toastPop) {
      setTimeout(() => {
        setToastPop(false);
      }, 5000);
    }
  }, [toastPop]);
  // need list of promotions
  return (
    <div
      style={{
        flex: 1,
        backgroundColor: BlackAndWhite.secondary,
        height: height - 60,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          minHeight: 50,
          //   borderStyle: "solid",
          width: "100%",
          display: "flex",
          alignItems: "center",
        }}
      >
        <div
          style={{
            height: "100%",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            marginRight: 150,
            width: 300,

            borderWidth: 0.5,
          }}
        >
          <TextInputFieldSearch
            placeholder={"Type here to search"}
            height={25}
            borderRadius={4}
            onChange={(e) => setSearch(e.target.value)}
            value={search}
          />
          <div
            style={{
              height: 30,
              width: 70,
              backgroundColor: BlackAndWhite.primary,
              borderRadius: 4,
              display: "flex",
              color: BlackAndWhite.secondary,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              onClick={() => setSearch("")}
              style={{ fontSize: 12, fontWeight: "bold" }}
            >
              CLEAR
            </div>
          </div>
        </div>
        <div style={{ flex: 1 }} />
        <BaseButtons
          mini={true}
          label={"REFRESH"}
          marginTopFalse={true}
          height={"90%"}
          size={100}
          onClick={() => getPromotionList()}
          marginRight={5}
        />
        <BaseButtons
          mini={true}
          label={"+ ADD PROMOTION"}
          marginTopFalse={true}
          height={"90%"}
          size={180}
          onClick={() => setAddPromotionsPopUp(true)}
        />
      </div>
      <PromotionsTable
        setSelectedPromo={setSelectedPromo}
        data={promotionCardArray}
        search={search}
      />
      {addPromotionsPopUp ? (
        <AddPromtions
          setClose={setAddPromotionsPopUp}
          category={category}
          auth={auth}
          setMessage={setMessage}
          setToastPop={setToastPop}
        />
      ) : null}
      {selectedPromo ? (
        <ManagePromotions
          setClose={setSelectedPromo}
          selectedPromo={selectedPromo}
          category={category}
          auth={auth}
          setMessage={setMessage}
          setToastPop={setToastPop}
        />
      ) : null}
      <LoadingPopUp display={loading} />
      <ToastNotification display={toastPop} message={message.toUpperCase()} />
    </div>
  );
};

export default Promotions;
